import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { COMPONENTS } from './components';
import { CoreDirectivesModule } from '../directives';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppModalModule } from 'app/core/modal';
import { TrackingPageCoreService } from './tracking-page-core.service';
import { MatMenuModule } from '@angular/material/menu';
import { CorePipesModule } from '../pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MODALS } from './modals';
import { PIPES } from './pipes';
import { Ng2FittextModule } from 'ng2-fittext';
import { SwiperModule } from 'swiper/angular';
import { MatDialogModule } from '@angular/material/dialog';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  imports: [
    CorePipesModule,
    CommonModule,
    CoreDirectivesModule,
    RouterModule,
    TooltipModule,
    ReactiveFormsModule,
    FormsModule,
    AppModalModule,
    TranslateModule,
    Ng2FittextModule,
    SwiperModule,
    MatMenuModule,
    MatDialogModule,
    DropdownModule
  ],
  providers: [TrackingPageCoreService],
  declarations: [COMPONENTS, PIPES, MODALS],
  exports: [COMPONENTS, PIPES, MatMenuModule]
})
export class TrackingPageModule {}
